<template>
  <div class="edit-account">
    <div>
      <h1 style="display: inline-block; margin-right: 2rem;">Update Account</h1>
      <b-button class="is-pulled-right"
                tag="router-link" to="/account">
        Go back to My Account
      </b-button>
    </div>

    <b-field label="Street 1">
      <b-input v-model="contact.street"></b-input>
    </b-field>

    <b-field label="Street 2">
      <b-input v-model="contact.street2"></b-input>
    </b-field>

    <b-field label="City">
      <b-input v-model="contact.city"></b-input>
    </b-field>

    <b-field grouped>
      <b-field label="State" expanded>
        <b-input v-model="contact.state" maxlength="2"></b-input>
      </b-field>

      <b-field label="Zipcode" expanded>
        <b-input v-model="contact.zipcode"></b-input>
      </b-field>
    </b-field>

    <b-field v-for="phone in contact.phones"
             :key="phone.uuid" grouped>

      <b-radio v-model="preferredPhoneUUID"
               :native-value="phone.uuid"></b-radio>

      <b-field label="Phone #" expanded>
        <b-input v-model="phone.number"></b-input>
      </b-field>

      <b-field label="Type">
        <b-select v-model="phone.type">
          <!-- TODO: these should probably come from server somehow -->
          <option value="Home">Home</option>
          <option value="Mobile">Mobile</option>
          <option value="Work">Work</option>
          <option value="Other">Other</option>
          <option value="Fax">Fax</option>
        </b-select>
      </b-field>

      <!-- TODO: seems a bit hacky here, to get icon aligned just right -->
      <div style="display: flex; flex-direction: column; padding-bottom: 1rem; ">
        <div style="flex: 1;"></div>
        <a href="#" @click.prevent="deletePhone(phone)" title="Remove this phone number">
          <b-icon icon="fas fa-trash" type="is-danger"></b-icon>
        </a>
      </div>
    </b-field>

    <div class="buttons is-centered">
      <b-button @click="addNewPhone()">Add New Phone</b-button>
    </div>

    <b-field v-for="email in contact.emails"
             :key="email.uuid" grouped>

      <b-radio v-model="preferredEmailUUID"
               :native-value="email.uuid"></b-radio>

      <b-field label="Email" expanded>
        <b-input v-model="email.address"></b-input>
      </b-field>

      <!-- TODO: seems a bit hacky here, to get icon aligned just right -->
      <div style="display: flex; flex-direction: column; padding-bottom: 1rem; ">
        <div style="flex: 1;"></div>
        <a href="#" @click.prevent="deleteEmail(email)" title="Remove this email address">
          <b-icon icon="fas fa-trash" type="is-danger"></b-icon>
        </a>
      </div>
    </b-field>

    <div class="buttons is-centered">
      <b-button @click="addNewEmail()">Add New Email</b-button>
    </div>

    <b-field grouped>
      <b-field label="Newsletter Preference"
               v-if="contact.member_active">
        <b-select v-model="contact.newsletter_preference">
          <option :value="null">(no preference)</option>
          <option value="digital">digital</option>
          <option value="paper">paper</option>
        </b-select>
      </b-field>
    </b-field>

    <div class="buttons is-pulled-right">
      <b-button type="is-primary" @click="submitForm()">Submit</b-button>
      <b-button tag="router-link" to="/account">Cancel</b-button>
    </div>
  </div>
</template>

<script>
export default {
    name: 'EditAccount',
    data() {
        return {
            inited: false,
            contact: {},
            preferredPhoneUUID: null,
            preferredEmailUUID: null,
        }
    },
    created: function() {
        this.init()
    },
    watch: {
        '$store.state.session_established': 'init',
    },
    methods: {

        init() {
            // only need to init once
            if (this.inited) {
                return
            }

            // cannot init until session is established
            if (!this.$store.state.session_established) {
                return
            }

            // go ahead and fetch data if someone is logged in
            if (this.$store.state.user.uuid) {
                this.fetchData()
            } else { // send logged-out users to "login" instead
                this.$router.push('/login')
            }

            // we did it!
            this.inited = true
        },

        fetchData() {
            this.$http.get('/api/my/contact').then(response => {
                this.contact = response.data
                this.preferredPhoneUUID = this.contact.phones ? this.contact.phones[0].uuid: null
                this.preferredEmailUUID = this.contact.emails ? this.contact.emails[0].uuid: null
            })
        },

        deletePhone(phone) {
            let i = this.contact.phones.indexOf(phone)
            if (i > -1) {
                this.contact.phones.splice(i, 1)
            }
        },

        addNewPhone() {
            this.contact.phones.push({
                uuid: null,
                number: "",
                type: "Home",
                preferred: false,
            })
        },

        deleteEmail(email) {
            let i = this.contact.emails.indexOf(email)
            if (i > -1) {
                this.contact.emails.splice(i, 1)
            }
        },

        addNewEmail() {
            this.contact.emails.push({
                uuid: null,
                address: "",
                preferred: false,
            })
        },

        submitForm() {

            // first we must update our "preferred" flags, in a way that the
            // backend will understand
            this.contact.phones.forEach(function(phone) {
                phone.preferred = phone.uuid == this.preferredPhoneUUID
            }, this)
            this.contact.emails.forEach(function(email) {
                email.preferred = email.uuid == this.preferredEmailUUID
            }, this)

            let params = {
                street_1: this.contact.street,
                street_2: this.contact.street2,
                city: this.contact.city,
                state: this.contact.state,
                zipcode: this.contact.zipcode,
                phone: this.contact.phones,
                email: this.contact.emails,
            }

            if (this.contact.member_active) {
                params.newsletter_preference = this.contact.newsletter_preference
            }

            this.$http.post('/api/my/contact/edit', params).then(response => {
                if (response.data.ok) {
                    this.$buefy.toast.open({
                        message: "Your account has been updated!",
                        type: 'is-success',
                    })
                    // go back to "my account" page
                    this.$router.push('/account')
                } else {
                    this.$buefy.toast.open({
                        message: response.data.error || "something went wrong!",
                        type: 'is-danger',
                    })
                }
            }, response => {
                this.$buefy.toast.open({
                    message: "something went wrong!",
                    type: 'is-danger',
                })
            })
        },
    },
}
</script>
